export const emptyTranslation = {
    key: 'strings:colonistCommon.utils.emptyString'
};
